
import { useSelector } from 'react-redux';


const styles = {
  img: {
    position: 'relative',
    width: '92px',
    height: '30px',
    left: '15px',
    borderRadius:'3px',
  }
};

function CompanyLogo(props: any) {
  const account = useSelector((state:any) => state.account);
  return (
    <img
      style={styles.img}
      alt=" "
      src={account.user.company.logo}
      {...props}
    />
  );
}

export default CompanyLogo;
